import client from "./client";
import { UserDetails, UserLogin, User } from "@lab/types/users";

const login = async (details: UserLogin): Promise<UserDetails | undefined> => {
	const response = await client.post(`/auth/login/data`, details);
	return response.data as UserDetails;
};

const resetpassword = async (details): Promise<undefined> => {
	const response = await client.post(`/auth/resetpassword`, details);
	return response.data as undefined;
};

const setpassword = async (details): Promise<undefined> => {
	const response = await client.post(`/auth/setpassword`, details);
	return response.data as undefined;
};

const validateToken = async (details): Promise<string | undefined> => {
	const response = await client.post(`/auth/validtoken`, details);
	return response.data as string;
};

const confirmInvite = async (details): Promise<string | undefined> => {
	const response = await client.post(`/auth/invite`, details);
	return response.data as string;
};

export { login, resetpassword, setpassword, validateToken, confirmInvite };
